import { Box, BoxProps, Spinner, Text } from '@razorpay/blade/components';

interface FullScreenLoaderProps {
  /**
   * Accessibility label for the spinner
   * @default "loading"
   */
  accessibilityLabel?: string;
  /**
   * Text to display next to the spinner
   * @default "Loading..."
   */
  loadingText?: string;
  /**
   * Direction of the layout
   * @default "row"
   */
  flexDirection?: 'row' | 'column';
  /**
   * Gap between spinner and text
   * @default "spacing.3"
   */
  gap?: BoxProps['gap'];
  /**
   * Height of the loader container
   * @default "100%"
   */
  height?: BoxProps['height'];
}

export const FullScreenLoader = ({
  accessibilityLabel = 'loading',
  loadingText = 'Loading...',
  flexDirection = 'row',
  gap = 'spacing.3',
  height = '100%',
}: FullScreenLoaderProps) => {
  return (
    <Box
      display="flex"
      flexDirection={flexDirection}
      alignItems="center"
      justifyContent="center"
      height={height}
      gap={gap}>
      <Spinner accessibilityLabel={accessibilityLabel} />
      <Text>{loadingText}</Text>
    </Box>
  );
};
